import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';
import { IconType } from '../../components/atoms/icon/icon';
import { IconCustomType } from '../../components/atoms/iconCustom/iconCustom';
import routes from '../../routes/route';
import formGraphicManagerVODManifestContent from './formGraphicManagerVODManifestContent';
import formSportRoomConfigContentMassUpdate from './formSportRoomConfigContentMassUpdate';
export default {
  attributeName: 'graphicManagerResourcesTable',
  isDragable: false,
  canOpen: true,
  canEdit: false,
  canCreate: false,
  canRemove: true,
  isMultiSelectable:false,
  newButton:true,
  editURL:'graphicmanagers/resource',
  getURL:'graphicmanagers/resources',
  updateURL:'graphicmanagers/resource',
  removeURL:'graphicmanagers/resource',
  deleteRecordText:"You are about to delete the graphic resource and it´s historic views. Are you totally sure?",
  popupContentFormNew:[formGraphicManagerVODManifestContent],
  popupContentFormEdit:[formGraphicManagerVODManifestContent],
  popupContentFormSecondary:[formSportRoomConfigContentMassUpdate],
  sessionParams: [],

  emptyMessage: "You don't have any graphic manifest on this manager, click on the \"+\" icon to create one.",
  fields: [
    // {
    //   attributeName: 'id',
    //   label: 'Id',
    //   type: FormInputTypes.TEXT,
    //   default: '',
    //   canOrder: false,
    //   canEdit: true,
    //   canCreate: true,
    //   canFilter: false,
    //   helpText: 'Content id.',
    // },
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: true,
      helpText: 'Name of the manifest.',
    },
    {
      attributeName: 'tags',
      label: 'Tags',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: true,
      helpText: 'Name of config.',
    },
    {
      attributeName: 'type',
      label: 'Type',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'Name of config.',
    },
    // {
    //   attributeName: 'inEpoch',
    //   label: 'In',
    //   type: FormInputTypes.TIME,
    //   default: '',
    //   canOrder: false,
    //   canEdit: true,
    //   canCreate: true,
    //   canFilter: false,
    //   helpText: 'In time.',
    // },
    // {
    //   attributeName: 'outEpoch',
    //   label: 'Out',
    //   type: FormInputTypes.TIME,
    //   default: '',
    //   canOrder: false,
    //   canEdit: true,
    //   canCreate: true,
    //   canFilter: false,
    //   helpText: 'Out time.',
    // },
    {
      attributeName: 'times',
      label: 'Times',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'Times included into the live.',
    },
    {
      attributeName: 'isLive',
      label: 'Is Live',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      hidden:true,
      canOrder: false,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      helpText: 'Times included into the live.',
    },
    {
      attributeName: 'url',
      type: FormInputTypes.LINKFRAME,
      label:"Preview",
      postUrl:'graphicmanagers/resource/out',
      swalTitle:'Preview Image',
      swalText:'Are you sure you want to drop the graphic from live?',
      icon: IconType.VIEW,
      width: '4rem',
      target:'_self',
      iconSize:'2x',
      iconColor:'#000000',
    },   
    // {
    //   attributeName: 'timeline',
    //   type: FormInputTypes.BUTTON_POPUP,
    //   postUrl:'graphicmanagers/resource/in',
    //   swalTitle:'Timeline',
    //   swalText:'Are you sure you want to set a timeline entry on this VOD?',
    //   icon:IconType.CLOCK,
    //   // iconWhen:{"field":"isLive","value":"FIXED","customIcon":IconCustomType.FIXED,"enabled":false,"else":({"field":"isLive","value":"LIVE","customIcon":IconCustomType.LIVE,"enabled":false,"else":{"customIcon":IconCustomType.IN,"enabled":true}})},
    //   width: '8rem',
    //   target:'_self',
    //   iconSize:'2x',
    //   iconColor:'#6CC24A',
    //   label:"Timeline"
    // },
    {
      attributeName: 'timeline',
      label: 'Timeline entry',
      type: FormInputTypes.BUTTON_POPUP,
      icon: IconType.CLOCK,
      width: '4rem',
      target:'_self',
      iconSize:'2x',
      iconColor:'#17a2b8',
      helpText: 'Create new timeline entry from this VOD.',
      // redirectUrl:'assetsmanager/graphicmanagers/run',
      actionUrl:'graphicmanagers/resource/timeline',
      refreshIfOk:true,
      formConfig:
        {
          title: 'Timeline entry',
          description:'Insert a new timeline entry for this VOD',
          attributeName: 'newTimelineEntry',
          fields: [
            {
              attributeName: 'inTime',
              helpText: 'Set the time to put it in',
              type: FormInputTypes.TEXT_INPUT.INPUT_TIME,
              useSeconds:true,
              required: true,
              label: 'In (time)',
              placeholder: 'Enter a valid time to put it in',
            },
            {
              attributeName: 'outTime',
              helpText: 'Set the time this to take it out',
              type: FormInputTypes.TEXT_INPUT.INPUT_TIME,
              required: true,
              useSeconds:true,
              label: 'Out (time)',
              placeholder: 'Enter a valid time to take it out',
            },
          ]
        }
    },   
  ],
};
